<template>
  <div>
    <!-- 사인 -->
    <table v-if="isPrint">
      <tbody>
        <tr>
          <td rowspan="2" class="title"><span class="mr-4">휴게시설 주요 체크리스트</span> {{ form.headerYear | moment("YYYY") }}년 {{ form.headerMonth | moment("MM") }}월</td>
          <td rowspan="2" class="titleCell bordered" style="width: 33px">결<br /><br /><br />재</td>
          <td class="titleCell signTitle bordered">담당자</td>
        </tr>
        <tr>
          <td class="signBody bordered">
            <div style="width: 125px; height: 80px">
              <img v-if="form.sign1.sign" :src="form.sign1.sign" />
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    <!-- 날짜 -->
    <div v-else class="absolute top-0 flex items-center gap-4" :class="[!isPrint && 'py-6']" style="left: calc(180px + 3.5rem)">
      <div class="flex items-center justify-center gap-3">
        <p v-if="isPrint" class="print-input">{{ form.headerYear | moment("YYYY") }}</p>
        <input v-else type="number" :readonly="board.readonly || isPostId" min="1800" max="9999" v-model="form.headerYear" style="width: 100px" />
        년
        <p v-if="isPrint" class="print-input">{{ form.headerMonth | moment("MM") }}</p>
        <input v-else type="number" :readonly="board.readonly || isPostId" min="1" max="12" v-model="form.headerMonth" style="width: 100px" @input="formatMonth" />
        월
      </div>
    </div>

    <!-- 기본정보 -->
    <field-select-module
      v-model="form.stdInfo"
      :board="this.board"
      :is-print="isPrint"
      :options="[
        { type: 'date', label: '점검일' },
        { type: 'text', label: '점검장소' },
        { type: 'disaster', label: '재해형태' },
      ]"
    />

    <table-inspect
      style="break-inside: auto !important;"
      class="mt-5"
      :is-print="isPrint"
      :is-readonly="board.readonly"
      :is-show-title="true"
      :title="form.inspectionTitle"
      :list="form.inspectList"
      :is-note="false"
      :table-header-title="'점검항목'"
      @update-list-check="updateListCheck"
    />

    <!-- 확인자 -->
    <div class="mt-8">
      <div>
        <h5><i class="dot"></i> 결재란</h5>
      </div>
      <name-with-signature-row label-name="작성자" :name.sync="form.sign1.name" :signature.sync="form.sign1.sign" />
      <name-with-signature-row label-name="검토자" :name.sync="form.sign2.name" :signature.sync="form.sign2.sign" />
      <name-with-signature-row label-name="회람자" :name.sync="form.sign3.name" :signature.sync="form.sign3.sign" />
      <name-with-signature-row label-name="승인자" :name.sync="form.sign4.name" :signature.sync="form.sign4.sign" />
    </div>

    <!--    사진대지-->
    <PhotoUploadGridModule :row-count="2" :grid-count="2" v-model="form.photoList" :is-print="isPrint" :readonly="board.readonly" section-title="사진대지" placeholder="신축현장 점검" />

    <!-- 파일첨부 -->
    <file-upload-module id="fileList" class="w-full mt-28px" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly"></file-upload-module>
  </div>
</template>

<script>
import FileUploadModule from "@/views/modules/FileUploadModule";
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import * as inspectData from "./inspectData";
import TableInspect from "@/components/TableInspect";
import SignField from "@/components/SignField.vue";
import PhotoUploadGridModule from "@/views/modules/PhotoUploadGridModule.vue";
import moment from "moment";
import NameWithSignatureRow from "@/components/NameWithSignatureRow.vue";

export default {
  components: {
    NameWithSignatureRow,
    PhotoUploadGridModule,
    SignField,
    TableInspect,
    FieldSelectModule,
    FileUploadModule,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  watch: {
    "value": {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    "form": {
      immediate: true,
      deep: true,
      handler(value) {
        value.title = this.board.writer.department;
        this.$emit("input", value);
      },
    },
    "form.headerYear": {
      immediate: true,
      deep: true,
      handler(value) {
        this.form.headerDate = String(this.form.headerYear) + String(this.form.headerMonth);
      },
    },
    "form.headerMonth": {
      immediate: true,
      deep: true,
      handler(value) {
        this.form.headerDate = String(this.form.headerYear) + String(this.form.headerMonth);
      },
    },
  },
  data() {
    return {
      form: {
        headerYear: moment(new Date()).format("YYYY"),
        headerMonth: moment(new Date()).format("MM"),
        headerDate: "",
        stdInfo: {},
        fileList: [],
        inspectionTitle: "휴게시설",
        inspectList: inspectData.inspectTable_1,

        inputA_1: "",

        sign1: {
          name: "",
          sign: "",
        },
        sign2: {
          name: "",
          sign: "",
        },
        sign3: {
          name: "",
          sign: "",
        },
        sign4: {
          name: "",
          sign: "",
        },
        photoList: [],
      },
    };
  },
  computed: {
    isPostId() {
      return !!this.$route.params.postId;
    },
    postList() {
      return this.$store.state.approval.list.map((item) => this.getContent(item));
    },
  },
  methods: {
    updateListCheck(indexRows, text) {
      this.form.inspectList[indexRows].is_checked = text;
    },
    formatMonth() {
      this.form.headerMonth = String(this.form.headerMonth).padStart(2, "0");
    },
  },
};
</script>

<style scoped lang="scss">
input[type="number"] {
  height: 40px;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 5px;
  padding: 0.7rem !important;
  transition: all 0.3s ease;

  &:focus {
    border: 1px solid rgba(var(--vs-primary), 1) !important;
    box-shadow: 0 3px 10px 0 rgba(0, 0, 0, 0.15);
  }
}

table {
  width: 100%;
  border-collapse: collapse;
  border-spacing: 0;

  td {
    border-right: 1px solid #cdcdcd;
    border-bottom: 1px solid #cdcdcd;
  }
  .title {
    font-size: 20px;
    font-weight: 500;
    line-height: 1.2;
    color: #2c2c2c;
    border: none;
    border-right: 1px solid #cdcdcd;
  }
  .signTitle {
    width: 125px;
    height: 38px;
  }
  .signBody {
    height: 100px;
    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }
}

.titleCell {
  border-top: 1px solid #cdcdcd;
  background-color: #f9f9f9;
  text-align: center;
}
</style>
